import {
    PageContainer,
    PageHeader,
    PageContent,
} from 'features/common/components/mobile/Page'
import Header from './components/Header'
interface FormStageContainerProps {
    title: string
    children: React.ReactNode
}
export const FormStageContainer = ({
    title,
    children,
}: FormStageContainerProps) => {
    return (
        <PageContainer>
            <PageHeader>
                <Header title={title} />
            </PageHeader>
            <PageContent>
                <div className="flex w-full flex-1 justify-center px-1 pt-9 pb-16 xs:py-12">
                    {children}
                </div>
            </PageContent>
        </PageContainer>
    )
}

export default FormStageContainer
